import React, { Component } from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import { deleteSocialMediaApi, getsocialMediaApi } from "./Api";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import editPencil from "../../assets/images/edit-icon.png";

import  SocialMediaForm from "./SocialMediaForm";
import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { connect } from "react-redux";
import { MODULE_ID_MAP, START_PAGE, contentMaster, isModuleExist } from "../../utils/Constant";
import { SOCIALMEDIA_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";
export class SocialMediaTab extends Component {
  constructor(props) {
    super(props);

    const AccesData = isModuleExist(MODULE_ID_MAP.ContentMasterSocialMedia);
    this.state = {
      access: AccesData,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,
      verified: '',
      verifyUrl: '',

      dummyData: [
        {
          id: 1,
          name: "Nirav",
        },
        {
          id: 2,
          name: "Mahesh",
        },
        {
          id: 3,
          name: "Dharmik",
        },
        {
          id: 4,
          name: "Uday",
        },
      ],
    };
  }
  // todo---------------------------------------
  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getsocialMediaApi(this);
  }
  // todo---------------------------------------

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {

    deleteSocialMediaApi(id, this, this.openCloseDeleteModal)
  }
  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = prevParams.get("pageSize") || "";

    const params = new URLSearchParams(this.props.location.search);
    const size = params.get("pageSize") || "";
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    // const search = params.get("search") || "";
    const verified = params.get("isVerified") || "";

    if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getsocialMediaApi(this);

      });
    }
  }
  // todo:-----------------------------------------

  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;

    return (
      <section className="request-section">

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.socialMediaName} social media?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.socialMediaName}'`}
          show={this.state.show}
          url={SOCIALMEDIA_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getsocialMediaApi(this) }}
        />
        {
          showEdit &&
          <SocialMediaForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
          />
        }
        <ComponentHeader
          title="Social Media"
          breadcrumb={[["Content Master", ""], ["Social Media", ""]]}
          primaryBtn={access.createAccess ? "Add Social Media" : ''}
          handlePrimaryBtn={() => {

            this.setState({ showEdit: true })
          }}
          ctx={this}
        />

        <Row>
          <Col sm={2}>
            <FilterVefiedDropDown ctx={this} />
          </Col>
        </Row>
        <div className="commom-table-wrapper">
          <CustomTable
          ctx={this}
            data={listData?.list || []}
            columns={[
              {
                width: 250,
                title: "Social Media Name",
                
                dataIndex: "socialMediaName",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.socialMediaName;
                },
              },
              {
                width: access.verificationAccess ? 100 : 0,
                title: "Verified",
                dataIndex: "isVerified",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                 const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                },
              },
              {
                width: 250,
                title: "Thumbnail Image",
                dataIndex: "thumbnailPath",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (rowData.thumbnailPath ? <Image src={rowData.thumbnailPath} className="table-img" alt="Photo" /> : "NA");
                },
              },
              {
                width: 250,
                title: "Home Image",
                dataIndex: "bannerPath",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (rowData.bannerPath ? <Image src={rowData.bannerPath} className="table-img" alt="Photo" /> : "NA");
                },
              },
              {
                width: 150,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.updatedBy?.name || 'Na';;
                },
              },
              {
                width: 150,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.createdBy?.name || 'Na';
                },
              },
              {
                width: 90,
                title: "Action",
                dataIndex: "",
                className: "",
                fixed: 'right',
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (
                      //  <div className="d-flex gap-3 justify-content-around">
                      //   {access.updateAccess && <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />}
                      //   {access.deleteAccess && <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />}
                      // </div>
                      <OptionsDropdown
                        editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                        deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                      />
                    );
                },
              },
            ]}
           
            total={listData?.length || 0}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}


const mapStateToProps = state => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getsocialMediaApi
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SocialMediaTab));
